// src/pages/TermsOfService.js
import React from 'react';

const TermsOfServicePage = () => {
  return (
    <div className="container mx-auto px-6 py-20 min-h-screen bg-[#0A1128] text-[#F8F8F8]">
      <h1 className="text-4xl sm:text-5xl font-extrabold mb-8 text-[#C9B072] text-center md:text-left">Terms of Service</h1>
      <div className="bg-[#1A2238] p-8 rounded-xl shadow-lg">
        <p className="text-lg leading-relaxed mb-4">
          Welcome to JAKOM! These Terms of Service ("Terms") govern your use of the JAKOM website and services. By accessing or using our website and services, you agree to be bound by these Terms and our Privacy Policy. If you do not agree to these Terms, please do not use our website or services.
        </p>

        <h2 className="text-3xl font-bold text-[#F8F8F8] mt-8 mb-4">1. Acceptance of Terms</h2>
        <p className="text-lg leading-relaxed mb-4">
          By accessing or using the JAKOM website and services, you signify your agreement to these Terms. We may modify these Terms at any time, and such modifications shall be effective immediately upon posting of the modified Terms. You agree to review the Terms periodically to be aware of such modifications and your continued access or use of the website shall be deemed your conclusive acceptance of the modified Terms.
        </p>

        <h2 className="text-3xl font-bold text-[#F8F8F8] mt-8 mb-4">2. Services</h2>
        <p className="text-lg leading-relaxed mb-4">
          JAKOM provides various digital services, including but not limited to Graphics & Design, Data Analysis, Accounting & Bookkeeping, Virtual Assistance, and Kids Hub educational programs. The specific terms and conditions for each service may be outlined in separate agreements or service descriptions.
        </p>

        <h2 className="text-3xl font-bold text-[#F8F8F8] mt-8 mb-4">3. User Obligations</h2>
        <p className="text-lg leading-relaxed mb-4">
          As a user of our website and services, you agree to:
        </p>
        <ul className="list-disc list-inside text-lg leading-relaxed mb-4 pl-4">
          <li>Provide accurate and complete information when requested.</li>
          <li>Use the services only for lawful purposes and in accordance with these Terms.</li>
          <li>Not engage in any activity that interferes with or disrupts the website or services.</li>
          <li>Be responsible for maintaining the confidentiality of your account information.</li>
        </ul>

        <h2 className="text-3xl font-bold text-[#F8F8F8] mt-8 mb-4">4. Intellectual Property</h2>
        <p className="text-lg leading-relaxed mb-4">
          All content on the JAKOM website, including text, graphics, logos, images, and software, is the property of JAKOM or its content suppliers and is protected by intellectual property laws. You may not reproduce, distribute, modify, or create derivative works of any content without our express written permission.
        </p>

        <h2 className="text-3xl font-bold text-[#F8F8F8] mt-8 mb-4">5. Limitation of Liability</h2>
        <p className="text-lg leading-relaxed mb-4">
          JAKOM will not be liable for any direct, indirect, incidental, special, consequential, or exemplary damages, including but not limited to, damages for loss of profits, goodwill, use, data, or other intangible losses resulting from the use or the inability to use the services.
        </p>

        <h2 className="text-3xl font-bold text-[#F8F8F8] mt-8 mb-4">6. Governing Law</h2>
        <p className="text-lg leading-relaxed mb-4">
          These Terms shall be governed by and construed in accordance with the laws of Kenya, without regard to its conflict of law provisions.
        </p>

        <h2 className="text-3xl font-bold text-[#F8F8F8] mt-8 mb-4">7. Contact Information</h2>
        <p className="text-lg leading-relaxed mb-4">
          If you have any questions about these Terms of Service, please contact us at:
        </p>
        <p className="text-lg leading-relaxed">
          Email: <a href="mailto:emmanuelomondiobare@gmail.com" className="text-[#4CAF50] hover:underline">emmanuelomondiobare@gmail.com</a><br />
          Phone: <a href="tel:+254794255000" className="text-[#4CAF50] hover:underline">+254 794 255 000</a>
        </p>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
